export default __webpack_public_path__ + "1c3a7ca03520fb9ee828b96c0ad0cff3.png";